/** @jsxImportSource @emotion/react */
import React, { ReactElement } from 'react';
import { Box, Container, Typography } from '@mui/material';
import { Page } from '../../components';

import NotFountImage from '../../assets/undraw_page_not_found_su7k.svg';
import { useNotFoundViewStyles } from './NotFoundView.styles';

export function NotFoundView(): ReactElement {
  const styles = useNotFoundViewStyles();

  return (
    <Page css={styles} title="404">
      <Box
        display="flex"
        flexDirection="column"
        height="100%"
        justifyContent="center"
      >
        <Container maxWidth="md">
          <Typography align="center" color="textPrimary" variant="h1">
            404: The page you are looking for isn’t here
          </Typography>
          <Typography align="center" color="textPrimary" variant="subtitle2">
            You either tried some shady route or you came here by mistake.
            Whichever it is, try using the navigation
          </Typography>
          <Box textAlign="center">
            <img className="emptyStateImage" src={NotFountImage} />
          </Box>
        </Container>
      </Box>
    </Page>
  );
}
